<template>
	<div class="upload-foto flex sm:flex-row sm:items-start flex-col items-center">
		<ld-upload name="foto" class="mr-5" :foto.sync="fotoObj" :default.sync="defaultFoto">
			<template v-slot:text>
				<feather-icon icon="UserIcon" svgClasses="h-12 w-12"/>
			</template>
		</ld-upload>

		<div class="flex flex-col mt-8">
			<div>
				<ld-button
					:disabled="foto || disabled"
					class="upload-foto-button sm:mr-4 sm:w-auto w-full"
					color="primary"
					type="filled"
					@click="escolherFoto"
					>Escolher foto</ld-button
				>

				<ld-button
					:disabled="!foto || disabled"
					class="upload-foto-button sm:w-auto sm:mt-0 mt-2 w-full"
					color="danger"
					type="border"
					@click="remover"
					>Remover</ld-button
				>
			</div>
			<h4 class="accept-text mt-2">Permitido JPG, JPEG ou PNG.</h4>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		foto: {
			required: false
		},
		default: {
			required: false
		},
		disabled: {
			required: false,
			default: false
		}
	},
	computed: {
		fotoObj: {
			set(value) {
				this.$emit("update:foto", value);
			},
			get() {
				return this.foto;
			}
		},
		defaultFoto: {
			get() {
				if (this.default) {
					return this.default;
				} else if (this.foto && this.foto instanceof File) {
					return URL.createObjectURL(this.foto);
				}

				return null;
			},
			set(value) {
				this.$emit("update:default", value);
			}

		}
	},
	methods: {
		escolherFoto() {
			const $input = this.$el.querySelector('input');
			if ($input) {
				$input.click();
			}
		},
		remover() {
			const $buttonClose = this.$el.querySelector('.upload-preview-close');
			if ($buttonClose) {
				$buttonClose.click();
			}
		}
	},
};
</script>

<style lang="scss">
.upload-foto {
	.ld-upload {
		width: 120px;
		height: 120px;
	}

	.upload-input,
	.upload-preview {
		border-radius: 50%;
	}

	.upload-input {
		pointer-events: none;

		.feather-icon {
			pointer-events: none;
		}
	}

	.upload-preview {
		button {
			top: 100%;
		}
	}

	.upload-foto-button {
		height: 38px;
	}

	.accept-text {
		font-size: 14px;
		font-weight: normal;
	}
}
</style>
